module.exports = {"HomeUrl":"http://www.meizuhomologado.com/#","site":"#FF6B00","logo":"https://yf-files.oss-cn-hongkong.aliyuncs.com/logo/logo_meizu.png","headerBg":"#ffffff","headerColor":"#222222","projectName":"Warranty Check","search_placeholder":"Enter your IMEI"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/appConfigs/meizu.json
// module id = nVI6
// module chunks = 1